/**
 * „Vyzkoušet na ukázkovém souboru" — stáhne vzorek a zabalí ho jako ``File``.
 *
 * KAN-2020: vzorový díl obchodu se servíruje z ``/processes/{slug}/sample-file``,
 * kde poslední segment URL není jméno souboru — jméno (a s ním přípona, podle
 * které analyzér pozná formát) přijde v ``Content-Disposition``. Starší CTA
 * odkazy (``…/process-samples/<uuid>.dxf``) jméno nesou v URL; to je záloha.
 */

function nameFromDisposition(header: string | null): string | null {
  if (!header) return null;
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(header);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1].trim()) || null;
  } catch {
    return match[1].trim() || null;
  }
}

/** Vzorek jako ``File``, nebo ``null``, když stáhnout nejde (zákazník nahraje vlastní). */
export async function fetchSampleFile(url: string): Promise<File | null> {
  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    const blob = await res.blob();
    const name =
      nameFromDisposition(res.headers?.get?.("Content-Disposition") ?? null) ||
      url.split("?")[0].split("/").pop() ||
      "sample";
    return new File([blob], name, { type: blob.type || "application/octet-stream" });
  } catch {
    return null;
  }
}
